export default __webpack_public_path__ + "static/media/insights-logo.6955ba26.svg";